import React from 'react'

export default function MapForm() {
    return (
        <>
            <div className="MapDiv">
                <h4>Locate us on Google maps</h4>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3173.224827063702!2d80.82289898984439!3d16.79287491541243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3675e5f312c661%3A0xab7189f421622491!2sIIIT%20Nuzvid%20Campus%2C%20Nuzividu%2C%20Andhra%20Pradesh%20521202!5e0!3m2!1sen!2sin!4v1608604552789!5m2!1sen!2sin" title="RGUKT NUZVID" frameBorder="0" allowFullScreen="" aria-hidden="true" tabIndex="0"></iframe>
            </div>
        </>
    )
}